export default {
  mainTabsLabels: ['Individual', 'Business'],
  personalData: {
    title: 'Personal data',
    captions: {
      fullName: 'Full Name',
      dateOfBirth: 'Date of birth',
      gender: 'Gender',
      maidenName: 'Previous/maiden name',
      phoneNumbers: 'Phone number(s)',
      emailAddress: 'Email address(es)',
      niNumber: 'NI Number',
      passportNumber: 'Passport number',
      drivingLicenceNumber: 'Driving licence number',
    },
  },
  businessData: {
    title: 'Business data',
    captions: {
      tradingAddresses: 'Trading address(es)',
      registeredAddress: 'Registered address',
      companyHouseRegNumber: 'Company House Reg Number',
      vatRegNumber: 'VAT Reg Number',
    },
  },
  address: {
    title: 'Address',
    captions: {
      currentAddress: 'Current address (inc date moved)',
      previousAddresses: 'Previous address(es)',
    },
  },
  bankAccounts: {
    title: 'Bank accounts',
    captions: {
      accountOpened: 'Date first account opened',
      hasActiveAccount: 'Has active account(s)',
    },
  },
  basicInfo: {
    reference: 'Reference',
    city: 'City',
    country: 'Country',
    ipAddress: 'IP Address',
    buttonLabels: {
      export: 'Export',
      delete: 'Delete',
    },
  },
  topRecurringTransactions: {
    title: 'Top Recurring Transactions',
    link: {
      label: 'see all',
      url: 'https://friendlyscore.com/',
    },
    tabLabels: ['Incomes', 'Expenditures'],
    tooltipInfo: [
      `A user’s transaction categories as ranked by the following stability measures (top three categories are shown):`,
      `Consistency:`,
      `how stable the transaction amounts in that category are over time.`,
      `Regularity:`,
      `how stable the intervals between transactions in that category are over time.`,
      `Longevity:`,
      `how long transactions in that category have been present in relation to the user’s account history`,
    ],
  },
  financialCredibility: {
    title: 'Financial Credibility',
    prosConsCaption: 'Reason codes',
    descriptionPrefix: 'Points out of',
    tooltipInfo: [
      `Financial Credibility is a predictive measure of a user’s ability to repay credit. Higher scores correspond to a higher predicted ability to repay.`,
    ],
  },
  liquidity: {
    title: 'Liquidity',
    tooltipInfo: [
      `Liquidity is a predictive measure of the near-term solvency of a user, which in turn serves as a key predictor of their capacity to repay credit. Higher scores correspond to a higher inferred capacity to repay.`,
    ],
  },
  incomeStability: {
    title: 'Income Stability',
    tooltipInfo: [
      `A user’s income as measured by the following stability measures: `,
      `Consistency:`,
      `how stable a user’s income amount is over time.`,
      `Regularity:`,
      `how stable the intervals are between a user receiving income payments.`,
      `Longevity:`,
      `how long the user has received an income in relation to their account history.`,
    ],
  },
  rentStability: {
    title: 'Rent Payment Stability',
    tooltipInfo: [
      `A user’s rent payments as measured by the following stability measures:`,
      `Consistency:`,
      `how stable a user’s rent payment amounts are over time.`,
      `Regularity:`,
      `how stable the intervals are between the user’s rent payments.`,
      `Longevity:`,
      `how long the user has been making rent payments in relation to their account history.`,
    ],
  },
  financialMarkers: {
    title: 'Financial Markers',
    subTitle: 'Proportion of Income',
    tooltipInfo: [
      `Indicators showing the percentage of a user’s income spent by category. These indicators offer deeper insights into a user’s creditworthiness.`,
    ],
  },
  events: {
    title: 'Events',
    tooltipInfo: [
      `Live feed of key events occurring across the user’s connected accounts.`,
    ],
  },
  eventsFeed: {
    title: 'Events Feed',
    noTitle: `It's empty`,
    noSubTitle: 'It seems that you don’t have any messages',
  },
  account: {
    title: 'Account',
    filtersSection: {
      headline: 'Select an account to see the details below',
      caption: 'Filter',
      currencyFilterLabel: 'Currency',
      currencyFilterValues: ['USD', 'EUR', 'PLN'],
      dateFilterLabel: 'Date',
      dateFilterValues: ['Some date', 'Some reusable-parts date'],
    },
    accountDetailsSection: {
      selectedId: 'Selected ID:',
      income: 'Income',
      expenditure: 'Expenditure',
      balance: 'Balance',
      maturity: 'Maturity',
      opening: 'Opening',
      id: 'ID',
    },
    chartSection: {
      tabLabels: ['Balance', 'Trend'],
    },
    incomeSection: {
      title: 'Income',
      link: {
        label: 'See all transactions',
        url: 'https://friendlyscore.com/',
      },
      tabLabels: ['All transactions', 'Recurring transactions'],
    },
    additionalInformationSection: {
      title: 'Additional Information',
      tabsLabels: ['Products', 'Beneficiary'],
    },
    expenditureSection: {
      title: 'Expenditure',
      link: {
        label: 'See all transactions',
        url: 'https://friendlyscore.com/',
      },
      tabLabels: ['All transactions', 'Recurring transactions'],
    },
    transactionsSection: {
      title: 'Transactions',
      tabLabels: [
        'All transactions',
        'Recurring transactions',
        'By categories',
      ],
    },
  },
  exportModal: {
    selectDateRangeCaption: 'Select date range',
    selectFileTypeCaption: 'Select file type',
    errors: {
      dateRangeInvalidOrPartiallyNull:
        'Selected date range is invalid. Both dates need to be provided. Please select valid time period.',
      dateRangeInvalid:
        'Selected date range is invalid. Please select valid time period.',
      accountPayloadEmpty:
        'You need to select at least one account to be exported.',
    },
  },
  exportModalSuccess: {
    dialogTitle: 'Export Success',
    alertTitle: 'Success',
    alertDescription: ['Your', 'Reports', 'are ready to be download :)'],
    subtitle: 'File list',
  },
  exportModalFail: {
    dialogTitle: 'Export Fail',
    alertTitle: 'Fail',
    alertDescription: [
      `Sorry, we couldn't generate your reports.`,
      `It's because of some internal issue.`,
      'To proceed please reload or close this window and try generating your reports again',
    ],
  },
  deleteModal: {
    dialogTitle: 'Delete Report',
    alertTitle: 'Warning!',
    alertDescription: [
      `Are you sure you would like to delete this report? This will delete all scores and cannot be undone!`,
    ],
  },
  deleteModalFail: {
    dialogTitle: 'Delete Report Fail',
    alertTitle: 'Fail',
    alertDescription: [
      `Sorry, we couldn't delete this report.`,
      `It's because of some internal issue.`,
      'To proceed please reload or close this window and try again',
    ],
  },
  deleteModalSuccess: {
    dialogTitle: 'Delete Report Success',
    alertTitle: 'Success',
    alertDescription: [`Your report is deleted now.`],
  },
  changeCategoryModal: {
    transactionLabel: 'Transaction',
    dialogTitle: 'Change category',
    transactionTitle: 'Edited Transaction',
    categoryTitle: 'Change category',
    categorySubTitle: 'Select a new category for this transaction',
    tagTitle: 'Help us classify better!',
    tagSubTitle:
      'Select words in the transaction label that are defining the new category',
    mainCategory: 'Main Category',
    subCategory: 'Subcategory',
    similarSubTitle: [
      'We found',
      'similar transactions, do you want to change them too?',
    ],
    similarCheckboxLabel: 'Yes, change all',
    currentSelectionLabel: 'Your current selection',
    noFinalCategorySelectedLabel: 'You also need to pick the subcategory',
    categoryLabel: 'Current category',
  },
  changeCategoryModalFail: {
    dialogTitle: 'Change Category Fail',
    alertTitle: 'Fail',
    alertDescription: [
      `Sorry, we couldn't change your transaction category.`,
      `It's because of some internal issue.`,
      'To proceed please reload or close this window and try again',
    ],
  },
  changeCategoryModalSuccess: {
    dialogTitle: 'Change Category Success',
    alertTitle: 'Success',
    alertDescription: [
      `Your transaction is changed now.`,
      `Transaction`,
      `is set now as`,
      `Also`,
      `similar transactions were modified accordingly`,
    ],
  },
  recurringTransactionsModal: {
    dialogTitles: {
      income: 'Recurring Income Transactions',
      expenditure: 'Recurring Expenditure Transactions',
      topExpenditure: 'Recurring Top Expenditure Transactions',
      topIncome: 'Recurring Top Income Transactions',
    },
    dialogSubTitle: 'Transaction history',
  },
};
